import React from "react";
import { HInput, passParamsThrough } from "../../../../validation/HForm";
import CopyIcon from "../../../../assets/icons/copy.svg";
import PlusIcon from "../../../../assets/icons/plus-small.svg";
import MinusIcon from "../../../../assets/icons/minus.svg";
import InputField from "./InputField";

const BaseTariffRow = ({
  number,
  isDiscountBonus,
  isDiscountBirthday,
  checkValueInput,
  isPurity,
  isThings,
  isCars,
  handleCopy,
  handleAddAfter,
  handleRemove,
  rows,
  control,
  register,
  errors,
}) => {
  const props = { control, register, errors };

  return passParamsThrough(
    <tr className="base-tariff">
      <th>
        <div className="form-element-data number">
          <HInput
            h="true"
            className="input"
            type="text"
            name={`rows[${number}].couponRowName`}
            id={`name${number}`}
          />
        </div>
      </th>
      <td>
        <div className="table-cellcontent flex-column hybrid">
          <div className="form-row flex-nowrap">
            <div className="form-row-item">
              <InputField
                h="true"
                name={`rows[${number}].startPrice`}
                id={`startPrice${number}`}
                decimals={2}
              />
            </div>
            <div className="form-row-item">
              <div className="form-element-data">
                <p>—</p>
              </div>
            </div>
            <div className="form-row-item">
              <InputField
                h="true"
                name={`rows[${number}].endPrice`}
                id={`endPrice${number}`}
                decimals={2}
              />
            </div>
          </div>
        </div>
      </td>
      <td>
        <InputField
          h="true"
          name={`rows[${number}].basePercentBonus`}
          id="basePercentBonus"
          decimals={2}
          readOnly={!isDiscountBonus}
          onClick={() => checkValueInput("basePercentBonus")}
        />
      </td>
      <td>
        <InputField
          h="true"
          name={`rows[${number}].basePercentBirthday`}
          id="basePercentBirthday"
          decimals={2}
          readOnly={!isDiscountBirthday}
          onClick={() => checkValueInput("basePercentBirthday")}
        />
      </td>
      {isPurity && (
        <td>
          <span className="caption">Базовый д/м</span>
          <InputField
            h="true"
            name={`rows[${number}].basePurity`}
            id={`basePurity${number}`}
            decimals={2}
          />
        </td>
      )}
      {isThings && (
        <td>
          <span className="caption">Базовый вещи</span>
          <InputField
            h="true"
            name={`rows[${number}].baseThings`}
            id={`baseThings${number}`}
            decimals={2}
          />
        </td>
      )}
      {isCars && (
        <td>
          <span className="caption">Базовый авто</span>
          <InputField
            h="true"
            name={`rows[${number}].baseCars`}
            id={`baseCars${number}`}
            decimals={2}
          />
        </td>
      )}
      {isPurity && (
        <td>
          <InputField
            h="true"
            name={`rows[${number}].delayPurity`}
            id={`delayPurity${number}`}
            decimals={2}
          />
        </td>
      )}
      {isThings && (
        <td>
          <InputField
            h="true"
            name={`rows[${number}].delayThings`}
            id={`delayThings${number}`}
            decimals={2}
          />
        </td>
      )}
      {isCars && (
        <td>
          <InputField
            h="true"
            name={`rows[${number}].delayCars`}
            id={`delayCars${number}`}
            decimals={2}
          />
        </td>
      )}
      <td>
        <div className="table-cell-actions">
          <button
            className="button-icontrigger"
            type="button"
            onClick={() => handleCopy(number)}
          >
            <span className="icon">
              <CopyIcon />
            </span>
          </button>
          <button
            className="button-icontrigger"
            type="button"
            onClick={() => handleAddAfter(number)}
          >
            <span className="icon">
              <PlusIcon />
            </span>
          </button>
          {!(rows.length === 1) && (
            <button
              className="button-icontrigger"
              type="button"
              onClick={() => handleRemove(number)}
            >
              <span className="icon">
                <MinusIcon />
              </span>
            </button>
          )}
        </div>
      </td>
    </tr>,
    props
  );
};

export default BaseTariffRow;
